import {
  BookOpen,
  Briefcase,
  Car,
  HeartPulse,
  Home,
  IdCard,
  Landmark,
  type LucideIcon,
  Scale,
  Shield,
} from 'lucide-react';
import { msg } from '@/shared/i18n/msg';
import type { DocumentCategory } from '../schemas/document-category';

export const DOCUMENT_CATEGORY_LABELS: Readonly<
  Record<DocumentCategory, { readonly label: string; readonly icon: LucideIcon }>
> = {
  identity: { label: msg('Identity'), icon: IdCard },
  legal: { label: msg('Legal'), icon: Scale },
  medical: { label: msg('Medical'), icon: HeartPulse },
  insurance: { label: msg('Insurance'), icon: Shield },
  property: { label: msg('Home and property'), icon: Home },
  finance: { label: msg('Finance'), icon: Landmark },
  vehicle: { label: msg('Vehicle'), icon: Car },
  manual: { label: msg('Manuals'), icon: BookOpen },
  other: { label: msg('Other'), icon: Briefcase },
};
